import { cn } from "@-/com.npmjs.cn";
import { cva, type VariantProps } from "@-/com.npmjs.cva";

const websiteGlowVariants = cva({
  base: "pointer-events-none absolute -z-10 rounded-full",
  defaultVariants: {
    blur: "lg",
    tone: "soft",
  },
  variants: {
    blur: {
      lg: "blur-[120px]",
      md: "blur-[90px]",
      sm: "blur-[70px]",
      xl: "blur-[140px]",
    },
    tone: {
      faint: "bg-website-accent/15",
      medium: "bg-website-accent/25",
      soft: "bg-website-accent/20",
      strong: "bg-website-accent/30",
      warm: "bg-website-accent-glow/60",
    },
  },
});

/**
 * A soft pool of brand-orange light behind a composition. Position and size it with `className`;
 * its parent must be a stacking context (`isolate`), which `WebsiteSection` and `WebsiteHeader`
 * already are.
 */
export function WebsiteGlow({
  blur,
  className,
  tone,
}: VariantProps<typeof websiteGlowVariants> & { className?: string }) {
  return <div aria-hidden={true} className={cn(websiteGlowVariants({ blur, tone }), className)} />;
}
